module.exports = __webpack_public_path__ + "static/media/edit.2b9d3fda.svg";